import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import {
  WuiButtonModule,
  AlertMessageModule,
  DialogComponentsModule,
  IconsModule,
  LoaderComponent,
} from 'wflow-ui';
import { TranslateModule } from '@ngx-translate/core';
import { FileControlComponent } from './file-control/file-control.component';
import { ImportFileDialogComponent } from './import-file-dialog.component';
import { ImportFileDialogService } from './import-file-dialog.service';

@NgModule({
  declarations: [ImportFileDialogComponent, FileControlComponent],
  providers: [ImportFileDialogService],
  imports: [
    CommonModule,
    TranslateModule,
    IconsModule,
    LoaderComponent,
    WuiButtonModule,
    DialogComponentsModule,
    AlertMessageModule,
  ],
  exports: [ImportFileDialogComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ImportFileDialogComponentModule {}
